import React, { Component } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid, TextField, Button } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import url from "src/serverURL";
import Revenue from "./Revenue";
import Expenses from "./Expenses";
import Analytics from "./Analytics";

class Navigation extends Component {
  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  constructor(props) {
    super(props);
    this.state = {
      revenueData: [],
      expenseData: [],
      analyticsData: [],
      value: "1",
      columns: [
        {
          label: "ID",
          field: "id",
          sort: "asc",
        },
        {
          label: "Account Title",
          field: "title",
          sort: "asc",
        },
        {
          label: "Debit (OB)",
          field: "opening_debit",
          sort: "asc",
        },
        {
          label: "Credit (OB)",
          field: "opening_credit",
          sort: "asc",
        },
        {
          label: "Debit (During)",
          field: "process_debit",
          sort: "asc",
        },
        {
          label: "Credit (During)",
          field: "process_credit",
          sort: "asc",
        },
        {
          label: "Debit (CB)",
          field: "closing_debit",
          sort: "asc",
        },
        {
          label: "Credit (CB)",
          field: "closing_credit",
          sort: "asc",
        },
      ],
      rows: [],
      call: () => {
        var columns = this.state.columns;
        var rows = this.state.rows;
        return { columns, rows };
      },
      id: 0,
      cash_accounts: [],
      bank_accounts: [],
      date_from: new Date().setMonth(new Date().getMonth() - 1),
      date_to: new Date(),
      final_flag: "",
      total_opening_debit: 0,
      total_opening_credit: 0,
      total_process_debit: 0,
      total_process_credit: 0,
      total_closing_debit: 0,
      total_closing_credit: 0,
      cash: true,
      bank: false,
      type: "customer",
      ac_title_data: null,
      all_accounts: {},
      original_record: [],
      body: "",
      title: "",
      opening_balance: 0,
      opening_flag: "",
      add: false,
      date: new Date(),
      save: false,
      avGbyInvoice: {},

      revenue: [],
      expense: [],
      analytics: [],
    };

    this.onSubmit = this.onSubmit.bind(this);
  }
  componentWillMount() {}
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  componentDidMount() {
    this.fetchData();
  }
  onSubmit(e) {
    e.preventDefault();
    this.fetchData();
  }
  fetchData() {
    this.setState({ total_opening_credit: 0 });
    this.setState({ total_opening_debit: 0 });
    this.setState({ total_process_credit: 0 });
    this.setState({ total_process_debit: 0 });
    var data = {
      from: this.state.date_from,
      to: this.state.date_to,
      module: "Profit_Loss",
    };
    this.setState({ save: true });

    data.clienttype = "";

    var OpeningDebit_COS = 0;
    var OpeningCredit_COS = 0;
    var ProcessDebit = 0;
    var ProcessCredit = 0;
    var ClosingDebit = 0;
    var ClosingCredit = 0;

    fetch(url + "inventry/reporting/avGbyInvoice", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((avGbyInvoice) => {
        this.setState({ avGbyInvoice: avGbyInvoice });

        fetch(url + "inventry/reporting/costofsales", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((transactions) => {
            //  console.log(transactions)
            var Opening1 = transactions.Opening;
            var During1 = transactions.During;

            //////////////////// Sorting Opening Data
            var key = Object.keys(Opening1).sort(function order(key1, key2) {
              if (new Date(Opening1[key1].date) < new Date(Opening1[key2].date))
                return -1;
              else if (
                new Date(Opening1[key1].date) > new Date(Opening1[key2].date)
              )
                return +1;
              else return 0;
            });

            var Opening = {};

            for (var i = 0; i < key.length; i++) {
              Opening[key[i]] = Opening1[key[i]];
              delete Opening1[key[i]];
            }

            ///////////////////

            //////////////////// Sorting During Data
            var key = Object.keys(During1).sort(function order(key1, key2) {
              if (new Date(During1[key1].date) < new Date(During1[key2].date))
                return -1;
              else if (
                new Date(During1[key1].date) > new Date(During1[key2].date)
              )
                return +1;
              else return 0;
            });

            var During = {};

            for (var i = 0; i < key.length; i++) {
              During[key[i]] = During1[key[i]];
              delete During1[key[i]];
            }

            ///////////////////

            var openingBalance = 0;
            var OpeningCredit = 0;
            var OpeningDebit = 0;
            // Opening

            Object.keys(Opening).map((key) => {
              if (key.includes("WV-S-") || key.includes("WV-PR-")) {
                OpeningDebit = OpeningDebit + this.state.avGbyInvoice[key];
              }
            });

            var openDiff = OpeningDebit;
            // SetUp the Opening of Cost of Sales
            if (openDiff > 0) {
              OpeningDebit_COS = openDiff;
            } else {
              OpeningCredit_COS = Math.abs(openDiff);
            }
            this.setState({ opening_flag: "Dr" });

            this.setState({ opening_balance: Math.abs(openDiff) });

            var OpeningBalanceValue = openDiff;
            var DuringCreditBalance = 0;
            var DuringDebitBalance = 0;
            var the_rows = [];

            var totalDebit = 0;
            var totalCredit = 0;
            var totalBalance = 0;
            var openDiff = 0;
            var flag = "";
            var counter = 0;
            // During

            Object.keys(During).map((key) => {
              var debit = 0;
              var credit = 0;
              var type = "";

              if (key.includes("WV-S-") || key.includes("WV-PR-")) {
                if (key.includes("WV-S-")) {
                  type = "Sale";
                }
                if (key.includes("WV-PR-")) {
                  type = "Purchase Return";
                }
                totalDebit = totalDebit + this.state.avGbyInvoice[key];
                if (counter == 0) {
                  DuringDebitBalance =
                    DuringDebitBalance +
                    this.state.avGbyInvoice[key] +
                    OpeningBalanceValue;
                } else {
                  DuringDebitBalance =
                    DuringDebitBalance + this.state.avGbyInvoice[key];
                }
                counter++;
                debit = this.state.avGbyInvoice[key];
              }

              var date = new Date(During[key].date);
              var d = date.getDate();
              var m = date.getMonth() + 1;
              var y = date.getFullYear();

              openDiff = DuringDebitBalance;

              flag = "Dr";

              //  the_rows.push(put_data)
            });
            if (flag == "Dr") {
              ProcessCredit = totalCredit;
              ProcessDebit = totalDebit;
              ClosingDebit = Math.abs(openDiff);
            } else {
              ProcessCredit = totalCredit;
              ProcessDebit = totalDebit;
              ClosingCredit = Math.abs(openDiff);
            }

            //////////////////////////////////////////////// Calling Up the Trail Balance
            var revenue = [];
            var expense = [];
            var analytics = [];

            fetch(url + "inventry/reporting/trial", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            })
              .then((res) => res.json())
              .then((transactions) => {
                var the_rows = [];
                var total_opening_credit = 0;
                var total_opening_debit = 0;
                var total_process_debit = 0;
                var total_process_credit = 0;
                var total_closing_debit = 0;
                var total_closing_credit = 0;
                transactions.push({
                  detail: { id: "C-1", name: "Cost of Sales", type: "COS" },
                  opening: {
                    credit: OpeningCredit_COS,
                    debit: OpeningDebit_COS,
                  },
                  process: { credit: ProcessCredit, debit: ProcessDebit },
                });

                var total_revenue = 0;
                var total_expense = 0;

                var analytics = [];

                analytics.push({
                  title: "Cost of Sales",
                  value: this.numberWithCommas(
                    (ProcessDebit == "0"
                      ? ProcessCredit
                      : ProcessDebit
                    ).toFixed(2)
                  ),
                });

                transactions.map((data) => {
                  if (
                    data.detail.name == "Credit Sales" ||
                    data.detail.name == "Cash Sales"
                  ) {
                    var put_data = {
                      id: data.detail.id,
                      title: data.detail.name,
                      type: data.detail.type,
                      value: this.numberWithCommas(
                        data.process.credit !== null &&
                          data.process.credit !== undefined
                          ? data.process.credit.toFixed(2)
                          : 0 // You can replace 0 with the default value you want in case credit is null or undefined
                      ),
                    };
                    total_revenue = total_revenue + data.process.credit;
                    revenue.push(put_data);
                  }

                  // Enable the oTHER iNCOME
                  if (
                    data.detail.name == "Discount" ||
                    data.detail.name == "Miscellaneous Income"
                  ) {
                    var put_data = {
                      id: data.detail.id,
                      title: data.detail.name,
                      type: data.detail.type,
                      value: this.numberWithCommas(
                        data.process.credit !== null &&
                          data.process.credit !== undefined
                          ? data.process.credit.toFixed(2)
                          : "N/A"
                      ),
                    };
                    console.log("Discount");
                    console.log(data.detail.name);
                    console.log("Credit");
                    console.log(data.process.credit);
                    console.log("Debit");
                    console.log(data.process.debit);
                    total_revenue = total_revenue + data.process.credit;
                    revenue.push(put_data);
                  }
                  if (
                    data.detail.id.includes("E-") &&
                    data.detail.id.split("-").length == 4
                  ) {
                    var put_data = {
                      id: data.detail.id,
                      title: data.detail.name,
                      type: data.detail.type,
                      value:
                        data.process.credit !== null &&
                        data.process.credit !== undefined
                          ? data.process.credit == "0" ||
                            data.process.credit == 0
                            ? this.numberWithCommas(
                                data.process.debit.toFixed(2)
                              )
                            : this.numberWithCommas(
                                data.process.credit.toFixed(2)
                              )
                          : "N/A", // Replace "N/A" with the default value you want in case credit is null or undefined
                    };
                    expense.push(put_data);

                    total_expense =
                      total_expense +
                      (data.process.credit == "0" || data.process.credit == 0
                        ? data.process.debit
                        : data.process.credit);
                    //expense.push(put_data)
                  }
                });
                var gross_profit =
                  total_revenue -
                  (ProcessDebit == "0" ? ProcessCredit : ProcessDebit);
                analytics.push({
                  title: "Gross Profit",
                  value: this.numberWithCommas(gross_profit.toFixed(2)),
                });
                analytics.push({
                  title: "Total Expense",
                  value: this.numberWithCommas(total_expense.toFixed(2)),
                });
                var net_profit_before_depreciation =
                  gross_profit - total_expense;
                analytics.push({
                  title: "Net Profit Before Depreciation",
                  value: this.numberWithCommas(
                    net_profit_before_depreciation.toFixed(2)
                  ),
                });
                analytics.push({
                  title: "Depreciation",
                  value: 0,
                });
                analytics.push({
                  title: "Net Profit After Depreciation",
                  value: this.numberWithCommas(
                    net_profit_before_depreciation.toFixed(2)
                  ),
                });
                analytics.push({
                  title: "Net Profit Before Tax",
                  value: this.numberWithCommas(
                    net_profit_before_depreciation.toFixed(2)
                  ),
                });
                analytics.push({
                  title: "Income Tax",
                  value: 0,
                });
                analytics.push({
                  title: "Net Profit",
                  value: this.numberWithCommas(
                    net_profit_before_depreciation.toFixed(2)
                  ),
                });

                this.setState({ revenue: revenue });
                this.setState({ expense: expense });
                this.setState({ analytics: analytics });
                this.setState({ save: false });
              });
          })
          .catch(() => {
            this.setState({ save: false });
          });
      });
  }

  Clear_Text = () => {
    try {
      const instance = this._typeahead_1.getInstance();
      instance.clear();
    } catch (e) {
      console.log(e);
    }
  };

  getData() {
    var columns = this.state.columns;
    var rows = this.state.rows;
    var filter = this.original;
    return { columns, rows };
  }
  handleChangeFrom = (date) => {
    this.setState({
      date_from: date,
    });
  };
  handleChangeTo = (date) => {
    this.setState({
      date_to: date,
    });
  };

  render() {
    const { value } = this.state;

    return (
      <>
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderColor: "divider", marginBottom: "0.5em" }}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TabList
                    onChange={this.handleChange}
                    aria-label="lab API tabs example"
                    sx={{
                      "& .css-6d3pg0-MuiTabs-indicator": {
                        backgroundColor:
                          value === "1"
                            ? "#01579b !important"
                            : value === "2"
                            ? "#FF0000 !important"
                            : value === "3"
                            ? "#069837 !important"
                            : "",
                      },
                    }}
                  >
                    <Tab
                      label="Revenue"
                      value="1"
                      sx={{
                        "&:hover": { color: "#01579b" },
                        "&.Mui-selected": { color: "#01579b" },
                      }}
                    />
                    <Tab
                      label="Expenses"
                      value="2"
                      sx={{
                        "&:hover": { color: "#FF0000" },
                        "&.Mui-selected": { color: "#FF0000" },
                      }}
                    />
                    <Tab
                      label="Analytics"
                      value="3"
                      sx={{
                        "&:hover": { color: "#069837" },
                        "&.Mui-selected": { color: "#069837" },
                      }}
                    />
                  </TabList>
                </Grid>
                <Grid item xs={6}>
                  <form onSubmit={this.onSubmit} className="Notifications">
                    <Grid container spacing={2}>
                      <Grid item xs={5}>
                        {" "}
                        <b>From :</b>
                        <br />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="dd/MM/yyyy"
                            value={this.state.date_from}
                            onChange={(date_from) => {
                              this.setState({ date_from: date_from });
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                            maxDate={this.state.date_to}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={5}>
                        <b>To :</b>
                        <br />
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            inputFormat="dd/MM/yyyy"
                            value={this.state.date_to}
                            onChange={(date_to) => {
                              this.setState({ date_to: date_to });
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} />
                            )}
                            maxDate={new Date()}
                            minDate={this.state.date_from}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={2}>
                        <br />
                        <Button
                          variant="contained"
                          size="md"
                          block
                          type="submit"
                          // disabled={this.state.save}
                        >
                          Search
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Box>
            <TabPanel value="1" style={{ padding: 0 }}>
              <Revenue
                revenueData={this.state.revenue}
                loading={this.state.save}
              />
            </TabPanel>
            <TabPanel value="2" style={{ padding: 0 }}>
              <Expenses
                expenseData={this.state.expense}
                loading={this.state.save}
              />
            </TabPanel>
            <TabPanel value="3" style={{ padding: 0 }}>
              <Analytics
                analyticsData={this.state.analytics}
                loading={this.state.save}
              />
            </TabPanel>
          </TabContext>
        </Box>
      </>
    );
  }
}

export default Navigation;
